import { useEffect, useState } from 'react';
import { putMonthlyRequestStatus } from '../../infra/api/putMonthlyRequestStatus';
import { useRecoilState, useRecoilValue } from 'recoil';
import * as Atom from '../recoil/index';
import { currencyKR, joinDtDate } from '../helper/filter';
import useNav from '../hooks/useNav';
import { beaconSelector } from '../recoil/selector';
import useBeacon from '../hooks/useBeacon';
import { PAGE_NM } from '../types/types';
import { useBaseParam } from '../hooks/useBaseParam';
import { ITableCell } from '../../ui/dataDisplay/InfoTable/InfoTable';

const useNotiPreInforms = () => {
  const [personal] = useRecoilState(Atom.personalInfo);
  const [openPopup, setPopup] = useState<boolean>(false);
  const [openPopupConfirm, setPopupConfirm] = useState<boolean>(false);
  const [informs, setInforms] = useState<ITableCell[]>([]);
  const [ctgGrpList] = useRecoilState(Atom.commonCodes);
  const [notiDetailInfo] = useRecoilState(Atom.notiDetailInfo);

  const { navigate } = useNav();

  const fetchMonthlyDetail = async () => {
    const info = notiDetailInfo;

    const job = ctgGrpList[1].list.find(
      (item: any) => item.code === info?.jobTyp,
    );
    const employee = ctgGrpList[2].list.find(
      (item: any) => item.code === info?.employeeTyp,
    );
    const businessTyp = ctgGrpList[4].list.find(
      (item: any) => item.code === info?.businessTyp,
    );
    const houseTyp = ctgGrpList[5].list.find(
      (item: any) => item.code === info?.houseTyp,
    );
    const joinDt = joinDtDate(info?.joinDt, '.');

    setInforms([
      { label: '직업 구분', value: job?.codeNm },
      { label: '소득 수준', value: currencyKR(info?.salaryAmt * 10000) },
      { label: '회사 명', value: info?.compNm || '없음' },
      {
        label: '고용 형태',
        value: employee?.codeNm || businessTyp?.codeNm || '없음',
      },
      { label: '입사 일자', value: joinDt || '없음' },
      { label: '주택 정보', value: houseTyp?.codeNm },
      { label: '차량 정보', value: info?.carNo || '없음' },
      { label: '알림 요청일', value: `매월 ${info?.hopeDay}일` },
    ]);
    // }
  };

  useEffect(() => {
    fetchMonthlyDetail();
  }, []);

  useEffect(() => {
    if (openPopupConfirm) {
      setTimeout(() => {
        setPopupConfirm(false);
        navigate('/main');
      }, 1000);
    }
  }, [openPopupConfirm]);

  const mutateMonthlyStatus = useBaseParam(putMonthlyRequestStatus, {
    custSeq: personal?.custSeq,
  });

  const cancelNoti = async () => {
    setPopup(false);
    await mutateMonthlyStatus();
    setPopupConfirm(true);
  };

  const beaconData = useRecoilValue(beaconSelector);
  const beacon = useBeacon({
    mediaCd: beaconData.mediaCd,
    custSeq: beaconData.custSeq,
    srcCd: beaconData.srcCd,
    pageName: PAGE_NM.NOTI_PRE_INFORMS,
  });
  useEffect(() => {
    beacon.sendViewPage();
  }, []);

  const sendBeaconClkBtnCnclSucc = (btnNm?: string) => {
    beacon.sendClkBtnCnclSucc({
      properties: { btnNm },
    });
  };

  return {
    openPopup,
    setPopup,
    cancelNoti,
    openPopupConfirm,
    setPopupConfirm,
    informs,
    sendBeaconClkBtnCnclSucc,
  };
};

export default useNotiPreInforms;
